import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <p class="alert alert-danger" ng-transclude></p>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/alert/error/index.js